import { SceStatus } from "..";
import { Log } from "../generic";
import { FileProps } from "../..";
import { OptionsEnum } from "../../utils";
import { User } from "../userTypes";

export enum RiskLevelEnum {
  LOW = 1,
  MEDIUM = 2,
  HIGH = 3,
}

export enum RiskLevelLabel {
  LOW = "Low",
  MEDIUM = "Medium",
  HIGH = "High",
}

export interface ContingencyPlanType {
  contingency_plan_code?: string;
  description?: string | undefined;
}

export type RecommendationResponse = {
  recommended_user: User | null;
  due_date: Date;
  recommendation: string | null;
  permanent_change: boolean | null;
  additional_mitigation_needed: boolean | null;
  potential_consequences_changed: boolean | null;
  has_action_to_be_closed?: boolean;
  temporary_due_date?: Date;
  tags?: string[] | null;
};

export type RecommendationCreate = {
  user_id: number | null;
  due_date: string | null;
  recommendation: string | null;
  permanent_change: boolean | null;
  additional_mitigation_needed: boolean | null;
  potential_consequences_changed: boolean | null;
  has_action_to_be_closed?: boolean | null;
  temporary_due_date?: string | null;
  tags?: string[] | null;
};

export interface Step2Props {
  potential_consequences_affected: string | null;
  potential_consequences_associated_comment: string;
  contingency_plan?: ContingencyPlanType | null;
  risk_level: RiskLevelEnum | null;
  risk_level_files: FileProps[] | undefined;
  assigning_recommendation_files?: FileProps[];
  mopo_reviewed: boolean | null | string;
  is_issue_managed_in_other_system: boolean | null | string;
  issue_id_in_other_system: string | null;
  risk_level_after_measures: RiskLevelEnum | null;
  risk_level_after_measures_comment: string | null;
  risk_level_after_measures_files?: FileProps[];
  approvals?:
    | {
        approved: boolean;
        comments: string;
        user: User | null;
      }[]
    | null;
  step_approved_by: User | null;
  step_approved_at: Date | null;
  draft: boolean;
}

/** Written by the frontend when the CTO evaluation saves an external element impact answer. */
export interface ExternalElementImpactBody {
  external_element_impacted: boolean | null;
}

/** Saved external element impact answer returned by the API. */
export interface ExternalElementImpactProps {
  external_element_impacted?: boolean | null;
}

export interface Step2Response
  extends Step2Props,
    ExternalElementImpactProps,
    Log {
  cto_code: string;
  assigning_recommendations: RecommendationResponse[];
  potential_consequences_associated: string[];
  sces: Omit<SceStatus, "expected_function" | "performance_standards">[];
  can_user_fill_step: boolean;
  eligible_users?: string[];
}

export interface CreateStep2Body extends Step2Props {
  assigning_recommendations: RecommendationCreate[];
  has_contingency_plan?: OptionsEnum;
  external_element_impacted?: boolean | null;
}

export interface NewStep2ApprovalForm {
  approved: boolean | null;
  comments?: string;
}
